export const RESET_USER_PROFILE = 'RESET_USER_PROFILE';

export const FETCH_USER_PROFILE_INIT = 'FETCH_USER_PROFILE_INIT';
export const FETCH_USER_PROFILE_SUCCESS = 'FETCH_USER_PROFILE_SUCCESS';
export const FETCH_USER_PROFILE_FAILURE = 'FETCH_USER_PROFILE_FAILURE';

export const FETCH_USER_PROFILE_DISCONNECT_FITBIT_INIT = 'FETCH_USER_PROFILE_DISCONNECT_FITBIT_INIT';
export const FETCH_USER_PROFILE_DISCONNECT_FITBIT_SUCCESS = 'FETCH_USER_PROFILE_DISCONNECT_FITBIT_SUCCESS';
export const FETCH_USER_PROFILE_DISCONNECT_FITBIT_FAILURE = 'FETCH_USER_PROFILE_DISCONNECT_FITBIT_FAILURE';

export const FETCH_USER_PROFILE_RESET_TOURS_INIT = 'FETCH_USER_PROFILE_RESET_TOURS_INIT';
export const FETCH_USER_PROFILE_RESET_TOURS_SUCCESS = 'FETCH_USER_PROFILE_RESET_TOURS_SUCCESS';
export const FETCH_USER_PROFILE_RESET_TOURS_FAILURE = 'FETCH_USER_PROFILE_RESET_TOURS_FAILURE';


// WEBPACK FOOTER //
// ./source/client/actions/user_profile/types.js